import React from 'react';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import useRouter from 'js/lib/useRouter';
import type { UrlSessionStoreContext } from 'js/lib/withUrlSessionStore';
import { UrlSessionStoreInternalContext, getUrlSessionStoreFromUrlParams } from 'js/lib/withUrlSessionStore';

export function useUrlSessionStore<T>(): UrlSessionStoreContext<T> {
  const router = useRouter();

  // To keep compatibility with the HOC version (`connectToUrlSessionStore`),
  // here try to retrieve the legacy context and return it if found.
  // this legacy context exists when `withUrlSessionStore()` is used to wrap the component tree.
  const internalContext = React.useContext(UrlSessionStoreInternalContext);
  if (internalContext.sessionStore) {
    return internalContext as UrlSessionStoreContext<T>;
  }

  // If legacy context does not exist, simply create the store from the query
  const sessionStore = getUrlSessionStoreFromUrlParams<T>(router.location.query);

  const pushWithSession: InjectedRouter['push'] = (pathOrLoc: $TSFixMe) => {
    let newPathOrLoc: typeof pathOrLoc;

    if (typeof pathOrLoc === 'string') {
      newPathOrLoc = pathOrLoc;
    } else {
      // newPathOrLoc uses default values from:
      // (1) router  (2) pathOrLoc
      // then add the getUrlParams() as query
      newPathOrLoc = {
        params: router.params,
        ...pathOrLoc,

        query: {
          ...router.location.query,
          ...pathOrLoc.query,
          ...sessionStore.getUrlParams(),
        },
      };
    }

    router.push(newPathOrLoc);
  };

  return { sessionStore, pushWithSession };
}

export default useUrlSessionStore;
